import { render } from "./App.vue?vue&type=template&id=347c2c14"
const script = {}

import "./App.vue?vue&type=style&index=0&id=347c2c14&lang=css"
script.render = render

export default script